import { initializeApp, FirebaseApp, getApp } from 'firebase/app'
import { firebaseConfig } from '../../config'

/**
 * Firebase App Initialization
 *
 * Ensures Firebase app is initialized only once and only for cloud deployments.
 * This is called lazily by Firebase providers (Analytics, Remote Config) when they need it.
 */

let firebaseApp: FirebaseApp | null = null

/**
 * Initialize Firebase app if not already initialized
 * Returns the Firebase app instance
 *
 * This is safe to call multiple times - it will only initialize once
 */
export function initializeFirebase(): FirebaseApp {
  if (firebaseApp) {
    return firebaseApp
  }

  try {
    // Try to get existing app first
    firebaseApp = getApp()
  } catch {
    // App doesn't exist yet, initialize it
    firebaseApp = initializeApp(firebaseConfig)
  }

  return firebaseApp
}

/**
 * Check if Firebase has been initialized
 */
export function isFirebaseInitialized(): boolean {
  return firebaseApp !== null
}
